import { render, staticRenderFns } from "./MainCalendar.vue?vue&type=template&id=00e3e224&scoped=true"
import script from "./MainCalendar.vue?vue&type=script&lang=js"
export * from "./MainCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e3e224",
  null
  
)

export default component.exports